import { useState } from 'react';
import { useAudio } from './AudioProvider.jsx';

function formatVolumeLabel(volume) {
  return `${Math.round(volume * 100)}%`;
}

function AudioControls({ preferences, updatePreferences }) {
  return (
    <>
      <label className="audio-settings-row">
        <input
          type="checkbox"
          checked={preferences.musicEnabled}
          onChange={(event) =>
            updatePreferences({ musicEnabled: event.currentTarget.checked })
          }
        />
        <span>Music</span>
      </label>
      <label className="audio-settings-row">
        <input
          type="checkbox"
          checked={preferences.effectsEnabled}
          onChange={(event) =>
            updatePreferences({ effectsEnabled: event.currentTarget.checked })
          }
        />
        <span>Sound effects</span>
      </label>
      <label className="audio-settings-volume">
        <span>Volume</span>
        <strong>{formatVolumeLabel(preferences.volume)}</strong>
        <input
          type="range"
          min="0"
          max="100"
          step="5"
          value={Math.round(preferences.volume * 100)}
          onChange={(event) =>
            updatePreferences({
              volume: Number(event.currentTarget.value) / 100
            })
          }
        />
      </label>
    </>
  );
}

export function AudioSettings({ variant = 'toggle' }) {
  const { preferences, updatePreferences } = useAudio();
  const [open, setOpen] = useState(false);

  if (variant === 'inline') {
    return (
      <div
        className="audio-settings audio-settings-inline"
        data-testid="audio-settings-inline"
      >
        <AudioControls
          preferences={preferences}
          updatePreferences={updatePreferences}
        />
      </div>
    );
  }

  return (
    <div className="audio-settings">
      <button
        type="button"
        className="audio-settings-toggle"
        aria-label="Audio settings"
        aria-expanded={open}
        aria-controls="audio-settings-panel"
        title="Audio settings"
        onClick={() => setOpen((value) => !value)}
        data-testid="audio-settings-toggle"
      >
        <svg
          className="audio-settings-icon"
          viewBox="0 0 24 24"
          aria-hidden="true"
          focusable="false"
        >
          <path d="M4 9v6h4l5 4V5L8 9H4z" />
          <path d="M16 9.5a4 4 0 0 1 0 5" />
          <path d="M18.5 7a7 7 0 0 1 0 10" />
        </svg>
      </button>
      {open ? (
        <div
          id="audio-settings-panel"
          className="audio-settings-panel"
          data-testid="audio-settings-panel"
        >
          <AudioControls
            preferences={preferences}
            updatePreferences={updatePreferences}
          />
        </div>
      ) : null}
    </div>
  );
}
